const projectServiceName = "/Project";

export function ProjectService(http) {
    return {        
        getAllProjectTypes: () => {
            return http.get(projectServiceName + "/GetProjectTypes")
        },
    }
}

